import TermsOfUse from "./components/terms-of-use/terms-of-use";
import PageWrapper from "../wrappers/page-wrapper";

TermsOfUse.domainName = "terms-of-use";

export default PageWrapper(TermsOfUse);
